if (!customElements.get('theme-slider-v-1-legacy')) {
  customElements.define(
    'theme-slider-v-1-legacy',
    class ThemeSliderV1 extends HTMLElement {
      constructor() {
        super();
        if (!this.slider) return;
        this.createSlider();
      }

      get slider() {
        return this.hasAttribute('data-slider') ? this.dataset.slider : null;
      }

      get space() {
        return this.hasAttribute('data-space') ? Number(this.dataset.space) : 10;
      }

      createSlider() {
        const slider_el = document.querySelector(`.${this.slider} .slider`);
        const slides = slider_el.querySelectorAll('.featured-product');
        if (slides.length > 3 && slides.length < 5) {
          if (window.innerWidth >= 1280) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .featured-product-slider`, {
            slidesPerView: 1.25,
            speed: 500,
            spaceBetween: this.space,
            breakpoints: {
              480: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1280: {
                enabled: false,
                slidesPerView: 'auto',
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .featured-product-pagination`,
              type: 'progressbar',
            },
          });
        } else if (slides.length < 4) {
          if (window.innerWidth >= 768) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .featured-product-slider`, {
            slidesPerView: 1.25,
            speed: 500,
            spaceBetween: this.space,
            breakpoints: {
              480: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 'auto',
                enabled: false,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .featured-product-pagination`,
              type: 'progressbar',
            },
          });
        } else if (slides.length == 5) {
          if (window.innerWidth >= 1440) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .featured-product-slider`, {
            slidesPerView: 1.25,
            speed: 500,
            spaceBetween: this.space,
            breakpoints: {
              480: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1440: {
                slidesPerView: 'auto',
                enabled: false,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .featured-product-pagination`,
              type: 'progressbar',
            },
          });
        } else if (slides.length > 5) {
          new Swiper(`.${this.slider} .featured-product-slider`, {
            slidesPerView: 1.25,
            speed: 500,
            spaceBetween: this.space,
            breakpoints: {
              480: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 4,
              },
              1440: {
                slidesPerView: 5,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .featured-product-pagination`,
              type: 'progressbar',
            },
          });
        }
      }
    },
  );
}

if (!customElements.get('theme-slider-v-2-legacy')) {
  customElements.define(
    'theme-slider-v-2-legacy',
    class ThemeSliderV1 extends HTMLElement {
      constructor() {
        super();
      }

      #tabsSlider = null;

      get slider() {
        return this.hasAttribute('data-slider') ? this.dataset.slider : null;
      }

      connectedCallback() {
        this.createSlider();
        this.initVideoPlaying();
        this.scrollToSlide();
      }

      createSlider() {
        const settings = {
          observer: true,
          observeParents: true,
          slidesPerMove: 1,
          slidesPerView: 1.15,
          spaceBetween: 24,
          slidesOffsetAfter: 24,
          breakpoints: {
            681: {
              slidesPerView: 1.5,
            },
          },
        };

        this.#tabsSlider = new Swiper(`.${this.slider} .slider`, settings);
      }

      initVideoPlaying() {
        const videos = document.querySelectorAll(`.${this.slider} video`);
        if (videos.length === 0) return;
        videos.forEach((video) => {
          this.observVideo(video);
        });
      }

      observVideo(video) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                video.play();
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.9 },
        );
        observer.observe(video);
      }

      scrollToSlide() {
        const options = document.querySelectorAll(`.${this.slider} [data-option-index]`);
        if (options.length === 0) return;
        options.forEach((option) => {
          option.addEventListener('click', () => {
            options.forEach((option) => option.classList.remove('active'));
            option.classList.add('active');
            this.#tabsSlider.slideTo(Number(option.dataset.optionIndex));
          });
        });
      }
    },
  );
}

if (!customElements.get('theme-slider-v-3-legacy')) {
  customElements.define(
    'theme-slider-v-3-legacy',
    class ThemeSliderV1 extends HTMLElement {
      constructor() {
        super();
        if (!this.slider) return;
        this.createSlider();
      }

      get slider() {
        return this.hasAttribute('data-slider') ? this.dataset.slider : null;
      }

      get space() {
        return this.hasAttribute('data-space') ? Number(this.dataset.space) : 10;
      }

      createSlider() {
        const slider_el = document.querySelector(`.${this.slider} .slider`);
        const slides = slider_el.querySelectorAll('.card');
        if (slides.length > 3 && slides.length < 5) {
          if (window.innerWidth >= 1280) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .slider`, {
            slidesPerView: 1,
            speed: 750,
            loop: true,
            autoplay: {
              delay: 4000,
            },
            spaceBetween: this.space,
            breakpoints: {
              650: {
                slidesPerView: 2,
              },
              950: {
                slidesPerView: 3,
              },
              1280: {
                enabled: false,
                slidesPerView: 'auto',
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .pagination`,
              clickable: true,
            },
          });
        } else if (slides.length < 4) {
          if (window.innerWidth >= 1280) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .slider`, {
            slidesPerView: 1,
            speed: 750,
            loop: true,
            autoplay: {
              delay: 4000,
            },
            spaceBetween: this.space,
            breakpoints: {
              650: {
                slidesPerView: 2,
              },
              950: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: 'auto',
                enabled: false,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .pagination`,
              clickable: true,
            },
          });
        } else if (slides.length == 5) {
          if (window.innerWidth >= 1440) {
            slider_el.parentNode.classList.add('disabled');
          }
          new Swiper(`.${this.slider} .slider`, {
            slidesPerView: 1,
            speed: 750,
            loop: true,
            autoplay: {
              delay: 4000,
            },
            spaceBetween: this.space,
            breakpoints: {
              650: {
                slidesPerView: 2,
              },
              950: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: 4,
              },
              1440: {
                slidesPerView: 'auto',
                enabled: false,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .pagination`,
              clickable: true,
            },
          });
        } else if (slides.length > 5) {
          new Swiper(`.${this.slider} .slider`, {
            slidesPerView: 1,
            speed: 750,
            loop: true,
            autoplay: {
              delay: 4000,
            },
            spaceBetween: this.space,
            breakpoints: {
              650: {
                slidesPerView: 2,
              },
              950: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: 4,
              },
              1440: {
                slidesPerView: 5,
              },
            },
            navigation: {
              nextEl: `.${this.slider} .next-slide`,
              prevEl: `.${this.slider} .prev-slide`,
            },
            pagination: {
              el: `.${this.slider} .pagination`,
              clickable: true,
            },
          });
        }
      }
    },
  );
}
